import { BreadcrumbItem } from "../type";

export const getBreadcrumbsTranslations = (
  breadCrumbsData: BreadcrumbItem[],
  translations: string[]
) => {
  return breadCrumbsData.map((item, index) => {
    if (!item.link) return { label: translations[index] };

    return { label: translations[index], link: item?.link };
  });
};
